import { useEffect } from "react";
import { useAuthStore } from "../../stores/auth";
import { usePresenceStore } from "../../stores/presence";

const HEARTBEAT_INTERVAL_MS = 30_000;

function HeartbeatProvider() {
  const me = useAuthStore((state) => state.me);
  const heartbeat = usePresenceStore((state) => state.heartbeat);

  useEffect(() => {
    if (!me) return;

    heartbeat();
    const id = setInterval(heartbeat, HEARTBEAT_INTERVAL_MS);

    return () => clearInterval(id);
  }, [me, heartbeat]);

  return null;
}

export default HeartbeatProvider;
